module.exports = __webpack_public_path__ + "static/media/logo.570f0f89.png";